import { render, staticRenderFns } from "./ChangePass.vue?vue&type=template&id=a1786a38&scoped=true&"
import script from "./ChangePass.vue?vue&type=script&lang=ts&"
export * from "./ChangePass.vue?vue&type=script&lang=ts&"
import style0 from "./ChangePass.vue?vue&type=style&index=0&id=a1786a38&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1786a38",
  null
  
)

export default component.exports